import { Action } from 'redux';
import { cloneDeep } from 'lodash';
// Import States.
import {
	AppState,
} from '@app/redux/states';
// Import Actions.
import {
	AddNotificationAction,
	DeleteNotificationsAction,
} from '@app/redux/actions';
// Import App Models.
import {
	AppNotification
} from '@app/models/app';


/**
 * This handles initializing the state.
 * @param state
 */
let initializeState = (state: AppState): AppState => {
	let newState: AppState = { ...state };
	// Initialize the notifications.
	newState.notifications = cloneDeep<AppNotification[]>(newState.notifications);
	return newState;
}


// Add Notification Reducer.

let AddNotificationReducer = (state: AppState, action: Action): AppState => {
	let addNotificationAction: AddNotificationAction = action as AddNotificationAction;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state);

	// Add new notification instance
	newState.notifications.push(new AppNotification({
		title: addNotificationAction.title,
		primaryMessage: addNotificationAction.primaryMessage,
		secondaryMessage: addNotificationAction.secondaryMessage,
		type: addNotificationAction.notificationType,
		timeout: addNotificationAction.notificationTimeout,
	}));

	return newState;
}


// Delete Notifications Reducer.

let DeleteNotificationsReducer = (state: AppState, action: Action): AppState => {
	let deleteNotificationsAction: DeleteNotificationsAction = action as DeleteNotificationsAction;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state);

	// Delete any notification with matching id's to the inputs.
	deleteNotificationsAction.ids.forEach((id: string) => {
		let index: number = newState.notifications.findIndex((appNotification: AppNotification) => {
			return appNotification.id === id
		});

		if (index !== -1) {
			newState.notifications.splice(index, 1);
		}
	});

	return newState;
}


// Flush Notification Reducers

let FlushNotificationsReducer = (state: AppState, action: Action): AppState => {
	// Create copy of the of app state.
	let newState: AppState = initializeState(state);
	newState.notifications = [];
	return newState;
}

// Export Reducers.
export {
	AddNotificationReducer,
	DeleteNotificationsReducer,
	FlushNotificationsReducer
};